import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/list-master/treatment-master";

export const Route = createFileRoute("/admin/_list-master/treatment-master")({
  component: Page,
});
